import type { SRT_SortingState } from '@/shared/components/master-table'

import { useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
	MasterTable,
	useMasterReactTable,
} from '@/shared/components/master-table'
import { getMasterTableLocale } from '@/shared/i18n'

import { getColumns } from '../lib/columns'

export function AnchorProductTable() {
	const { t } = useTranslation()

	const [sorting, setSorting] = useState<SRT_SortingState>([])
	const { watch } = useFormContext()
	const columns = useMemo(() => getColumns(t), [])
	const table = useMasterReactTable({
		localization: getMasterTableLocale(),
		data: [watch('anchorProduct')!],
		columns,
		state: {
			sorting,
		},
		layoutMode: 'grid',
		getRowId: (row) => row?.sales_entity_id,
		onSortingChange: setSorting,
		enableVirtualization: true,
		enableColumnResizing: true,
		enableColumnActions: false,
	})

	return <MasterTable table={table} />
}
